module.exports = __webpack_public_path__ + "static/media/eating-lunch-out.c8aaa8e8.svg";